import { selectOrderId } from 'entities/orders';
import { selectPersonId } from 'entities/person';
import { selectTagsForOrderMap, selectTagsForPersonMap } from 'entities/tags';
import { FC, useEffect, useState } from 'react';
import { MAIN_COLOR } from 'shared/consts';
import { useAppSelector } from 'shared/lib/store';
import { TagCard } from 'shared/ui/cards/tagCard';
import { Flex } from 'shared/ui/flex';
import { TagsGrid, TagsOverflow } from './styles';

interface TagsProps {
	tags: string[];
	tagsFor: 'person' | 'order';
	currentEntityId: number;
	doubleRows?: boolean;
}

export const Tags: FC<TagsProps> = ({
	tags,
	tagsFor = 'order',
	currentEntityId,
	doubleRows,
}) => {
	const tagsForOrder = useAppSelector(selectTagsForOrderMap);
	const tagsForPerson = useAppSelector(selectTagsForPersonMap);
	const [overflowCount, setOverflowCount] = useState(0);

	const selectedOrderId = useAppSelector(selectOrderId);
	const selectedPersonId = useAppSelector(selectPersonId);

	const [selectedEntityId, setSelectedId] = useState(0);
	const [tagsMap, setTagsMap] = useState<Map<string, { value: string; color: string }>>();

	useEffect(() => {
		if (tagsFor === 'order') {
			setTagsMap(tagsForOrder);
		} else {
			setTagsMap(tagsForPerson);
		}
	}, [tagsFor, tagsForOrder, tagsForPerson]);

	useEffect(() => {
		if (tagsFor === 'person') {
			setSelectedId(selectedPersonId);
		}
	}, [selectedPersonId, tagsFor]);

	useEffect(() => {
		if (tagsFor === 'order') {
			setSelectedId(selectedOrderId);
		}
	}, [selectedOrderId, tagsFor]);

	const calcElements = () => {
		const tags = document.querySelectorAll(`.list-tag-${currentEntityId}`);

		const count = Array.from(tags)?.filter((element: any) => {
			return element.offsetTop > 50
		})?.length;

		setOverflowCount(count);
	}

	useEffect(() => {
		setTimeout(calcElements, 500);
		// eslint-disable-next-line
	}, [tags]);

	useEffect(() => {
		window.addEventListener('resize', calcElements);

		return () => window.removeEventListener('resize', calcElements);
		// eslint-disable-next-line
	}, [])

	if (doubleRows) {
		return (
			<TagsGrid id="container">
				{tags.map((tag) => {
					return (
						<TagCard
							className={`list-tag-${currentEntityId}`}
							key={tag}
							name={tag}
							variant="default"
							border={tagsMap?.get(tag)?.color}
              bg={tagsMap?.get(tag)?.color}
							outputCloseButton={false}
							typographyProps={{
								isBold: false,
								pointer: true,
								mode: "smaller"
							}}
						/>
					);
				})}
				{Boolean(overflowCount) && (
					<TagsOverflow>
						<TagCard
							name={`+${overflowCount}`}
							variant="secondary"
							border={selectedEntityId === currentEntityId ? MAIN_COLOR : 'none'}
							outputCloseButton={false}
							typographyProps={{
								colorVariant: "main",
								isBold: true,
								pointer: true,
								mode: "smaller"
							}}
						/>
					</TagsOverflow>
				)}
			</TagsGrid>
		)
	}

	return (
		<Flex $gap="5px" $wrap="wrap" $cursor="pointer">
			{tags.map((tag, index) => {
				if (index > 3) {
					return;
				}
				return (
					<TagCard
						key={tag}
						name={index === 3 ? `+${String(tags.length - 3)}` : tag}
						variant={index === 3 ? 'secondary' : 'default'}
						border={
							index !== 3
								? tagsMap?.get(tag)?.color
								: selectedEntityId === currentEntityId
									? MAIN_COLOR
									: 'none'
						}
						outputCloseButton={false}
						typographyProps={{
							colorVariant: index === 3 ? 'main' : 'default',
							isBold: index === 3,
							pointer: true,
							mode: "smaller"
						}}
					/>
				);
			})}
		</Flex>
	);
};
